import { render, staticRenderFns } from "./RubricPurInBillModal.vue?vue&type=template&id=6dd448fe&scoped=true&"
import script from "./RubricPurInBillModal.vue?vue&type=script&lang=js&"
export * from "./RubricPurInBillModal.vue?vue&type=script&lang=js&"
import style0 from "./RubricPurInBillModal.vue?vue&type=style&index=0&id=6dd448fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd448fe",
  null
  
)

export default component.exports